import Component from "@base/js/component";

export default class PerformanceRow extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".performance-row";

  // Defines children that needs to be queried as part of this component
  static children = {
    rowItemsContainer: [".performance-row__item"],
  };

  // Defines event handlers to attach to children
  eventHandlers = {};

  afterInit() {
    const { rowItemsContainer } = this.children;

    const self = this;
    // to make sure that dom is rendered
    setTimeout(() => {
      rowItemsContainer.forEach((rowItemsParent) => {
        const seeMoreBtn = rowItemsParent.querySelector(
          ".performance-row__item-see-more"
        );
        const rowItems = rowItemsParent.querySelector(
          ".performance-row__item-links"
        );

        if (seeMoreBtn) {
          self.updateRowItemHeight(rowItems);
          const initialHeight = rowItems.getAttribute("data-collapse-height");
          rowItems.style.maxHeight = `${initialHeight}px`;

          seeMoreBtn.addEventListener("click", (ev) => {
            ev.preventDefault();
            if (rowItems.classList.contains("links-expanded")) {
              const height = rowItems.getAttribute("data-collapse-height");
              rowItems.style.maxHeight = `${height}px`;
              rowItems.classList.remove("links-expanded");
            } else {
              const height = rowItems.getAttribute("data-expanded-height");
              rowItems.style.maxHeight = `${height}px`;
              rowItems.classList.add("links-expanded");
            }
          });
        }
      });

      window.addEventListener("resize", () => {
        this.updateRowHeightOnResize();
      });
    }, 250);
  }

  updateRowHeightOnResize() {
    const { rowItemsContainer } = this.children;

    rowItemsContainer.forEach((rowItemsParent) => {
      const rowItems = rowItemsParent.querySelector(
        ".performance-row__item-links"
      );
      this.updateRowItemHeight(rowItems);
    });
  }

  updateRowItemHeight(rowItems) {
    let totalCollapseHeight = 0;
    let totalExpandedHeight = 0;
    rowItems.querySelectorAll("li").forEach((el, index) => {
      const elementHeight = el.getBoundingClientRect().height;
      if (index < 3) {
        totalCollapseHeight += elementHeight;
      }
      totalExpandedHeight += elementHeight;
    });
    rowItems.setAttribute("data-collapse-height", `${totalCollapseHeight}`);
    rowItems.setAttribute("data-expanded-height", `${totalExpandedHeight}`);

    if (rowItems.classList.contains("links-expanded")) {
      const height = rowItems.getAttribute("data-expanded-height");
      rowItems.style.maxHeight = `${height}px`;
    } else {
      const height = rowItems.getAttribute("data-collapse-height");
      rowItems.style.maxHeight = `${height}px`;
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
PerformanceRow.init();
